import React from 'react';
import { observer } from 'mobx-react';

import QuestionYesNoComponent from './Type/QuestionYesNoComponent';
import QuestionTextComponent from './Type/QuestionTextComponent';
import QuestionDropDownComponent from './Type/QuestionDropDownComponent';
import QuestionnaireQuestionAnswerDetail from '../../Models/Questionnaires/Queries/QuestionnaireQuestionAnswerDetail';
import { QuestionType } from '../../Models/Enums/QuestionType';
import QuestionnaireAnsweredLookup from '../../Models/Questionnaires/Queries/QuestionnaireAnsweredLookup';
import QuestionMultiSelectDropDownComponent from './Type/QuestionMultiSelectDropDownComponent';

interface IQuestionComponentProps {
    questionAnswered: QuestionnaireAnsweredLookup | null;
    questionNumber: number;
    questionAnswer: QuestionnaireQuestionAnswerDetail;
    disabled: boolean;
}

@observer
export default class QuestionComponent extends React.Component<IQuestionComponentProps> {
    public render() {
        const answer = this.props.questionAnswer;
        return (
            <div>
                {(answer.questionType === QuestionType.ShortText ||
                    answer.questionType === QuestionType.LongText) &&
                    <QuestionTextComponent
                        questionNumber={this.props.questionNumber}
                        question={answer}
                        questionAnswered={this.props.questionAnswered}
                        disabled={this.props.disabled} />}
                {answer.questionType === QuestionType.DropDown &&
                    <QuestionDropDownComponent
                        questionNumber={this.props.questionNumber}
                        question={answer}
                        questionAnswered={this.props.questionAnswered}
                        disabled={this.props.disabled} />}
                {answer.questionType === QuestionType.MultiSelectDropDown &&
                    <QuestionMultiSelectDropDownComponent
                        questionNumber={this.props.questionNumber}
                        question={answer}
                        questionAnswered={this.props.questionAnswered}
                        disabled={this.props.disabled} />}
                {answer.questionType === QuestionType.YesOrNo &&
                    <QuestionYesNoComponent
                        questionNumber={this.props.questionNumber}
                        question={answer}
                        questionAnswered={this.props.questionAnswered}
                        disabled={this.props.disabled} />}
            </ div >
        )
    }
}
